export default {
  model: {
    prop: 'visible',
    event: 'updateVisibility',
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    selectedUsers: {
      default: () => [],
      type: Array,
    },
  },
  methods: {
    handleMainAction() {
      this.handleClose();
      this.emitContinue();
    },
    emitContinue() {
      this.$emit('continue');
    },

    handleClose() {
      this.$emit('updateVisibility', false);
    },
  },
};
